/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Quick_Workout_Never_PlanInputs */

const en_us2_quick_workout_never_plan = /** @type {(inputs: Quick_Workout_Never_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Doesn't change your plan.`)
};

const pt_br2_quick_workout_never_plan = /** @type {(inputs: Quick_Workout_Never_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não muda o seu plano.`)
};

const es_419_quick_workout_never_plan = /** @type {(inputs: Quick_Workout_Never_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No cambia tu plan.`)
};

const pt_pt2_quick_workout_never_plan = /** @type {(inputs: Quick_Workout_Never_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não muda o teu plano.`)
};

const fr_fr2_quick_workout_never_plan = /** @type {(inputs: Quick_Workout_Never_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ne modifie pas ton programme.`)
};

const de_de2_quick_workout_never_plan = /** @type {(inputs: Quick_Workout_Never_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ändert deinen Plan nicht.`)
};

const it_it2_quick_workout_never_plan = /** @type {(inputs: Quick_Workout_Never_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non cambia la tua scheda.`)
};

/**
* | output |
* | --- |
* | "Doesn't change your plan." |
*
* @param {Quick_Workout_Never_PlanInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const quick_workout_never_plan = /** @type {((inputs?: Quick_Workout_Never_PlanInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Quick_Workout_Never_PlanInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_quick_workout_never_plan(inputs)
	if (locale === "es-419") return es_419_quick_workout_never_plan(inputs)
	if (locale === "pt-PT") return pt_pt2_quick_workout_never_plan(inputs)
	if (locale === "fr-FR") return fr_fr2_quick_workout_never_plan(inputs)
	if (locale === "de-DE") return de_de2_quick_workout_never_plan(inputs)
	if (locale === "it-IT") return it_it2_quick_workout_never_plan(inputs)
	return en_us2_quick_workout_never_plan(inputs)
});
export { quick_workout_never_plan as "quick-workout.never_plan" }